import type CacheStore from '../cache/CacheStore';
import GlobalCacheStore from '../cache/GlobalCacheStore';

/**
 * Id generator for unique id's.
 */
export default class IdGenerator {
	private cache: CacheStore;

	/**
	 * @param cache
	 */
	constructor(cache: CacheStore = new GlobalCacheStore()) {
		this.cache = cache;
	}

	/**
	 * Generates a unique id from the cache.
	 *
	 * @param cache
	 * @returns Unique id.
	 */
	public generateId(): string {
		const store = this.cache.getStore('IdGenerator');
		const id = store.get('id') || 0;

		store.set('id', id + 1);

		return 'kompis' + (id + 1);
	}
}
